<template>
  <section>
    <header class="header-image ken-burn-center light" data-parallax="true"
            data-natural-height="500" data-natural-width="1920" data-bleed="0"
            data-image-src="../media/header1_staubli.jpg" data-offset="0">
      <div class="container">
        <h1>STAUBLI</h1>
        <h2>CONECTORES MC4</h2>
      </div>
    </header>
    <main>
      <section class="section-base">
        <div class="container">
          <div class="row row-fit-lg">
            <div class="col-lg-12">
              <p align="justify">
                A Stäubli está presente no Brasil há mais de 40 anos. Sua unidade central, na cidade
                de São Paulo, conta com engenheiros de aplicação e equipe comercial para as três
                atividades: Connectors, Robotics e Textile. Também possui salas de treinamento
                técnico, show room, serviços, assistência técnica especializada e estoque de peças
                para reposição.<br><br>

                &nbsp;&nbsp;A história da Stäubli no Brasil começou nos anos 70 com inauguração da
                fábrica na cidade de Diadema no estado de São Paulo, a fábrica seguiu atuando por
                duas décadas até ser extinta no início da década de 90 quando o cenário econômico
                gerou a necessidade da abertura de um escritório comercial.<br><br>

                &nbsp;&nbsp;Desde 1996, a Stäubli Brasil está estabelecida na cidade de São Paulo, a
                maior metrópole da América do Sul, ao longo das décadas expandiu sua área de
                cobertura e hoje reúne condições de atender todo o território nacional, além de
                algumas localidades fora do Brasil, sempre seguindo os atributos da nossa matriz:
                dinâmico, colaborativo e confiável.<br><br>

                &nbsp;&nbsp;A unidade da Stäubli no Brasil conta com engenheiros de aplicação e
                equipe comercial.<br><br>
              </p>
              <img :src="require('Assets/images/photo_staubli1.jpg')">
              <br>
              <img :src="require('Assets/images/photo_staubli2.jpg')">
            </div>
          </div>
        </div>
      </section>
      <MarcasParceiras></MarcasParceiras>
      <br><br>
    </main>
  </section>
</template>

<script>
import MarcasParceiras from 'Homepage/common/MarcasParceiras.vue';

export default {
  name: 'Staubli',
  components: {
    MarcasParceiras,
  },
};
</script>

<style scoped>
header {
  height: 250px !important;
  background-image: url("../../assets/images/header1_staubli.jpg");
}
header .container {
  padding-top: 50px !important;
}
header h2 {
  color: #0098da !important;
  line-height: 37px;
  text-transform: uppercase !important;
  font-weight: 700 !important;
  margin: 0 !important;
  font-size: 14px !important;
}

</style>
